import { TS_PaymentType }       from '../TravelSeller/Models/TS_PaymentType';
import { BookingItemInterface } from './BookingItemInterface';

export class PaymentType extends TS_PaymentType implements BookingItemInterface {
  paymentAccountHolder: string;
  paymentIban: string;
  paymentBic: string;
  agreement: string;
}